import { useState } from 'react';
import { Transition } from '@headlessui/react';
import useTimeout from '@/hooks/useTimeout';
import PartnersLogosAnimation, { PartnerLogo } from './PartnersLogosAnimation';

export default function PartnersHeroAnimation() {
  const [show, setShow] = useState(false);

  useTimeout(() => setShow(true), 0);

  return (
    <div className="hidden md:block absolute top-0 bottom-0 right-0 w-3/5 z-10">
      <PartnersLogosAnimation />
      <Transition show={show}>
        <Transition.Child
          enter="transition-opacity duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-300 transform"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div
            className="rounded-full absolute z-0 top-0 right-0 transform translate-x-48 origin-top -mt-20 bg-green-200"
            style={{
              width: '870px',
              height: '870px',
            }}
          >
            <div
              className="absolute z-10 rounded-full bg-green-300 flex items-center justify-center"
              style={{
                width: '596px',
                height: '596px',
                top: '136px',
                left: '136px',
              }}
            >
              <div
                className="animate-spin-slow absolute border border-white rounded-full"
                style={{
                  width: '466px',
                  height: '466px',
                }}
              >
                <div
                  className="absolute w-4 h-4 rounded-full bg-white"
                  style={{ top: '-8px', left: '233px' }}
                />
                <div
                  className="absolute w-4 h-4 rounded-full bg-white"
                  style={{ top: '80px', left: '41px' }}
                />
                <div
                  className="absolute w-4 h-4 rounded-full bg-white"
                  style={{ bottom: '80px', left: '41px' }}
                />
                <div
                  className="absolute w-4 h-4 rounded-full bg-white"
                  style={{ bottom: '-8px', left: '233px' }}
                />
                <div
                  className="absolute w-4 h-4 rounded-full bg-white"
                  style={{ top: '80px', right: '41px' }}
                />
                <div
                  className="absolute w-4 h-4 rounded-full bg-white"
                  style={{ bottom: '80px', right: '41px' }}
                />
                <div
                  className="absolute w-4 h-4 rounded-full bg-white"
                  style={{ top: '233px', right: '-8px' }}
                />
                <div
                  className="absolute w-4 h-4 rounded-full bg-white"
                  style={{ top: '233px', left: '-8px' }}
                />
              </div>
              <div className="w-3/6 h-3/6 shadow-outside-light-lg flex relative z-50 rounded-full">
                <div className="w-full h-full rounded-full relative flex items-center justify-center">
                  <div className="opacity-40 absolute inset-0 bg-green-500 rounded-full" />
                  <PartnerLogo
                    src="v1612275132/socios/aibes_fntveq.png"
                    brandName="Asociación Iberoamericana de Scrum"
                    transitionDelay="delay-75"
                    animation="animate-float-random-1"
                  />
                </div>
              </div>
            </div>
            <div
              className="animate-spin-backwords-slow absolute z-0 left-0 top-0 border border-white rounded-full"
              style={{
                width: '740px',
                height: '740px',
                left: '60px',
                top: '60px',
              }}
            >
              <div
                className="absolute w-4 h-4 rounded-full bg-white"
                style={{ top: '-8px', left: '370px' }}
              />
              <div
                className="absolute w-4 h-4 rounded-full bg-white"
                style={{ top: '80px', left: '120px' }}
              />
              <div
                className="absolute w-4 h-4 rounded-full bg-white"
                style={{ bottom: '80px', left: '120px' }}
              />
              <div
                className="absolute w-4 h-4 rounded-full bg-white"
                style={{ bottom: '-8px', left: '370px' }}
              />
              <div
                className="absolute w-4 h-4 rounded-full bg-white"
                style={{ top: '80px', right: '120px' }}
              />
              <div
                className="absolute w-4 h-4 rounded-full bg-white"
                style={{ bottom: '80px', right: '41px' }}
              />
              <div
                className="absolute w-4 h-4 rounded-full bg-white"
                style={{ top: '370px', right: '-8px' }}
              />
              <div
                className="absolute w-4 h-4 rounded-full bg-white"
                style={{ top: '370px', left: '-8px' }}
              />
            </div>
          </div>
        </Transition.Child>
      </Transition>
    </div>
  );
}
